module.exports = __webpack_public_path__ + "dba740026e7290faa7d7c9c4668ce553.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/news/img1.jpg
// module id = 275
// module chunks = 0